import React, { useEffect, useState } from 'react';
import $ from "jquery";
import APIUrls from '../../../services/APIUrls';
import Constants from '../../../Constants';
import { transformBlankToNull } from '../../../services/Util';
import { postAxiosResponse } from '../../../services/authApiRoutes/APImethods';
import { textFieldValidation } from '../../../ValidationSchema';
import {ConditionalBlock} from '../../../ConditionalBlock';

export default function AddProjectTemplate({projectId,projectName,isEdit,action,setErrorMsg,setSuccessMsg,refreshProject,template}) {
    const [templateName, setTemplateName] = useState("");
    const [errors,setErrors] = useState({});

    useEffect(()=>{
        setTimeout(() => {
            $(".first-focus").trigger("focus");
            $("#template-name").on("keydown", function (e) {
              if (e.key === Constants.TAB) {
               if (e.shiftKey === true) {
                  e.preventDefault();
                  $("#template-name").trigger("focus");
                }
              }
            });
            $(".inner-lightbox-panel").on("keydown", function (e) {
              if (e.key === Constants.ESCAPE) {
                hideAddModal();
                $('.focusAdd').trigger('focus');
                $('.heading-with-rightbtn .blue-btn').removeClass('focusAdd');
              }
            });
          }, 500);
    },[]);

    useEffect(()=>{
      if(projectName !== undefined){
        if(isEdit){
          setTemplateName(template?.name);
        }else{
          setTemplateName(`${projectName}-template`);
        }
      }
    },[projectName])

    const hideAddModal = () => {
        setTemplateName(isEdit?template?.name:`${projectName}-template`);
        setErrors({});
        //setErrorMsg("");
        document.body.classList.remove("modal-open-9");
    };

    const handleKeyAddflow = (event) => {
        if (event.key === Constants.TAB) {
          if (event.shiftKey === false) {
            event.preventDefault();
            $("#template-name").trigger("focus");
          }
        }
    };

    const saveProjectTemplate = async(e) =>{
        e.preventDefault();
        const result = await textFieldValidation.validate({name:templateName},{abortEarly:false})
        .catch((err)=>{
          return err;
        });
        if(!result.errors){
          if(isEdit){
            let data = template;
            data.name = templateName;
            let payload = transformBlankToNull(data);
            action(payload,"Template renamed successfully");
            hideAddModal();
          }else{
            let data = {
              name:templateName,
              project:{id:projectId},
              enabled:true,
              deleted:false
            };
            let payload = transformBlankToNull(data);
            createNewTemplate(payload);
          }
        }else {
          let dataErrors = {};
          result.inner.forEach((element) => {
            dataErrors[element.path] = element.message;
          });
          setErrors(dataErrors);
        }
    };

    const createNewTemplate = (payload)=>{
      postAxiosResponse(APIUrls.PROJECT_TEMPLATE,payload).
          then((response)=>{
            const data = response.data.data;
            if(data === 1){
              setSuccessMsg("Template saved successfully");
              refreshProject();
            }else{
              setErrorMsg("Some error occured");
            }
            hideAddModal();
          }).catch((err)=>{
            console.error(err);
          });
    };

    return (
        <>
            <div className="lightbox-panel" id="modal-open-9" aria-labelledby="saveTemplate" aria-modal="true" role="dialog">
                <div className="inner-lightbox-panel sm-lightbox-pannel pb-0">
                    <div className="modal-header flex padd-lr">
                        <h5 id="saveTemplate">Save as Template</h5>
                    </div>
                    <div className="lightbox-content padd-22">
                        <div className="global-dropdown-block mar-bot6">
                            <label>Name</label>
                            <input type="text" className="form-control-sm" title="Template name"
                                id="template-name" value={templateName}
                                onChange={(e) => {setTemplateName(e.target.value);setErrors({})}} required
                            />
                            <ConditionalBlock condition={errors.name !== undefined}>
                              <p className="error">{errors.name}</p>
                            </ConditionalBlock>
                        </div>
                    </div>
                    <div className="modal-footer modal-footer-border flex px-22">
                        <button className="btn btn-bold first-focus cancelFocus" onClick={hideAddModal}>
                            Cancel
                        </button>
                        <button className={templateName?.trim().length >0? "btn btn-bold active" : "btn btn-bold active disabled-btn"}
                            id="addDepartment"
                            onClick={(e)=>saveProjectTemplate(e)} onKeyDown={handleKeyAddflow}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
